"use strict";

var _regeneratorRuntime = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _classCallCheck = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Multibox = require("../abi/Multibox.json");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var Multibox =
/*#__PURE__*/
function () {
  function Multibox(FDSAccount) {
    _classCallCheck(this, Multibox);

    var contractAddress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    this.account = FDSAccount;
    this.contractAddress = contractAddress;
    this.con = false;

    if (contractAddress !== false) {
      this.con = FDSAccount.getContract(_Multibox.abi, contractAddress);
    } else {
      return this.deploy();
    }

    return this;
  }

  _createClass(Multibox, [{
    key: "deploy",
    value: function deploy() {
      var _this = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var init;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.account.deployContract(_Multibox.abi, _Multibox.bytecode);

              case 2:
                _this.con = _context.sent;
                _this.contractAddress = _this.con.contractAddress;
                _context.next = 6;
                return _this.con.send('init', [], true);

              case 6:
                init = _context.sent;
                return _context.abrupt("return", _this);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }, {
    key: "getRoots",
    value: function getRoots() {
      var _arguments = arguments,
          _this2 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var address;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                address = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
                return _context2.abrupt("return", _this2.con.call('getRoots', []));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }]);

  return Multibox;
}();

var _default = Multibox;
exports.default = _default;
module.exports = exports.default;